import "./FideCfe.css"
import React from "react"
import { useInView } from "react-intersection-observer"

function FideCfe(){
    const {ref:fideycfe, inView:ficeycfeVisible} =useInView({
        "threshold":.5,
          "initialInView":true
      })
      const {ref:fideycfetext, inView:ficeycfetextVisible} =useInView({
        "threshold":1,
          "initialInView":true
      })
      const {ref:fideycfebutton, inView:ficeycfeButtonVisible} =useInView({
        "threshold":1,
          "initialInView":true
      })
      const {ref:InformacionImages, inView:ficeycfeImagesVisible} = useInView({
        "threshold":.75,
          "initialInView":true
      })
    return(
        <div className="FideCfeBox">
            <div ref={fideycfe} className={`ImagenesFideCfe ${ficeycfeVisible ? "ImagenesFideCfeAnimated" : ""}`}>
                <img id="ImagenFide" src="./Images/logofide.png"></img>
               <img id="ImagenesCfe" src="./Images/Comisión_Federal_de_Electricidad_(logo).jpg"></img>
            </div>
            <div className="FideCfeContent">
            <div className="infoboxFide">
                   
                <h3 ref={fideycfetext} className={`textFideCfeContent ${ficeycfetextVisible ? "textFideCfeAnimated": ""}`}>Sustituye equipos viejos por equipos nuevos con el programa FIDE de la CFE</h3>
                
                    <button ref={fideycfebutton} className={`informacionFideCfe ${ficeycfeButtonVisible ? "buttonFideCfeAnimated" : ""}`}>Más Información</button>
                    
                </div>
                <div ref={InformacionImages} className={`InformacionImgs ${ficeycfeImagesVisible ? "ImagesFideCfeAnimated" : "" }`}>
                    <img className="RefrisFide1" src="./Images/Refris Fide-01.png"></img>
                    <img className="RefrisFide2"src="./Images/Refris Fide-02.png"></img>
                </div>
            </div>

        </div>
    )
}

export default FideCfe;